<script setup lang="ts">
/***
 * template to show array of enums
 */
import YousignStatusBadge from '@/components/layouts/common-components/YousignStatusBadge.vue';
import type { PaginatedDataTableCellProps } from '@/components/paginated-datatable/templates/templateTypes';
import type { YouSignSignatureToDocumentV1Dto } from '@/openapi';
const props = defineProps<PaginatedDataTableCellProps>();
const cell = props.cell as Array<YouSignSignatureToDocumentV1Dto>;
</script>

<template>
  <ExpandableCell :data-key="dataKey" :field="column.field">
    <template #collapsed>
      <span v-if="cell?.length" class="flex gap-2">
        <span v-for="(arrayValue, arrayIndex) in cell" :key="arrayIndex">
          <YousignStatusBadge :status="arrayValue?.signature?.status" />
        </span>
      </span>
    </template>
    <template #expanded>
      <span v-if="cell?.length" class="flex gap-2">
        <span v-for="(arrayValue, arrayIndex) in cell" :key="arrayIndex">
          <pre>{{ arrayValue }}</pre>
        </span>
      </span>
    </template>
  </ExpandableCell>
</template>
